export default function DataBlock({title,style,children}){
    return(
        <div className={"data-block"+" data-"+style}>
            <div className="data-title">{title}</div>
            <div className="data-content">
                {children}
            </div>
        </div>
    )
}